import GenericPopupModal from 'components/GenericPopupModal/GenericPopupModal';
import { useAppDispatch, useAppSelector } from 'hooks';
import {
  selectIsEndLiveChatModalVisible,
  setIsEndLiveChatModalVisible,
} from 'reducers/live-chat';
import { Box } from '@mui/material';
import {
  selectIsCsatPromptableForEndLiveChat,
  setCsatStatesByKey,
} from 'reducers/workflows';
import { usePrepareLiveChatBeforeEndOfConversation } from 'components/App/hooks/usePrepareLiveChatBeforeEndOfConversation';
import { OrgThemedButton } from 'components/OrgThemedButton';
import { sendTrackingEvent } from 'actions/workflows/workflows';
import { endLiveChat } from 'actions/live-chat';

export const EndLiveChatModal = () => {
  const dispatch = useAppDispatch();
  const isEndLiveChatModalVisible = useAppSelector(
    selectIsEndLiveChatModalVisible,
  );
  const isCsatPromptable = useAppSelector(selectIsCsatPromptableForEndLiveChat);
  const prepareLiveChatBeforeEndOfConversation =
    usePrepareLiveChatBeforeEndOfConversation();

  const handleCloseModal = () => {
    dispatch(setIsEndLiveChatModalVisible(false));
  };

  const widgetEndLiveChat = async () => {
    handleCloseModal();
    prepareLiveChatBeforeEndOfConversation();

    // send tracking event
    dispatch(
      sendTrackingEvent({
        event_type: 'widget-customer-ended-live-chat',
      }),
    );

    /**
     * if user enables CSAT prompting after ending chat, we should show CSAT first
     */
    if (isCsatPromptable) {
      dispatch(
        setCsatStatesByKey({
          actionToExecuteAfterCsatDismiss: 'end-live-chat',
          isCsatVisible: true,
          triggeredFrom: 'end-live-chat',
        }),
      );
    } else {
      dispatch(endLiveChat());
    }
  };

  return (
    <GenericPopupModal
      content='Are you sure you want to end the live chat?'
      footer={
        <Box display='flex' gap={1} width='100%'>
          <OrgThemedButton
            color='error'
            fullWidth
            onClick={handleCloseModal}
            variant='outlined'
          >
            Cancel
          </OrgThemedButton>
          <OrgThemedButton
            fullWidth
            onClick={widgetEndLiveChat}
            variant='contained'
          >
            End Chat
          </OrgThemedButton>
        </Box>
      }
      isOpen={isEndLiveChatModalVisible}
      onClose={handleCloseModal}
      title='End Live Chat'
    />
  );
};
